export default {
    itens: [
        {
            name: 'Painel do Tesoureiro',
            url: '/painel-tesoureiro',
            icon: 'fas fa-home',
            groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
        },
        {
            name: 'Painel do Usuário',
            url: '/painel-usuario',
            icon: 'fas fa-solar-panel',
            groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-GOFS', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR']
        },
        {
            name: 'Honorários',
            url: '/honorarios',
            icon: 'fas fa-money-check-alt',
            groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-GOFS', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR']
        },
        {
            name: 'Receitas Diversas',
            url: '/receitas-diversas',
            icon: 'fas fa-money-check',
            groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-GOFS', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR']
        },
        {
            name: 'TRP',
            url: '/trp',
            icon: 'fas fa-money-check-alt',
            groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR']
        },
        {
            name: 'Pesquisas',
            url: '/pesquisas',
            icon: 'fa fa-search',
            groups: ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-GOFS', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR', 'SFEPGE-CES']
        },
        {
            name: 'Configurações',
            url: '#',
            icon: 'fas fa-cogs',
            groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO'],
            children: [
                {
                    name: 'Dados Bancários FEPGE',
                    url: '/parametro-credor',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: 'Dados Bancários CES',
                    url: '/parametro-credor-ces',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: `E-mail's ao Devedor`,
                    url: '/email-devedor',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: 'Índices',
                    url: '/indice',
                    groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
                },
                {
                    name: 'Salário Mínimo',
                    url: '/salario-minimo',
                    groups: ['SFEPGE-ADMINISTRADOR','SFEPGE-TESOUREIRO']
                },
                {
                    name: 'Regras de Pagamento',
                    url: '/regras-pagamento',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: 'Carga REFIS',
                    url: '/carga-refis',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: 'TRP',
                    url: '#',
                    icon: 'fas fa-money-check-alt',
                    groups: ['SFEPGE-ADMINISTRADOR'],
                    children: [
                        {
                            name: 'Cadastro',
                            url: '/tipo-trp',
                            groups: ['SFEPGE-ADMINISTRADOR']
                        },
                        {
                            name: 'Cancelamento',
                            url: '/cancelar-trp',
                            groups: ['SFEPGE-ADMINISTRADOR']
                        }
                    ]
                },
                {
                    name: 'Devedor',
                    url: '/devedor',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: 'Gestão de Boletos Não Encontrados',
                    url: '/boletos-nao-encontrados',
                    icon: 'fa fa-table',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: 'Consulta CDA WebService SEFA',
                    url: '/consulta-cda-webservice',
                    icon: 'fas fa-server',
                    groups: ['SFEPGE-ADMINISTRADOR']
                },
                {
                    name: 'Migração de Guias',
                    url: '/migracao-guias',
                    icon: 'fas fa-download',
                    groups: ['SFEPGE-ADMINISTRADOR']
                }
            ]
        }
    ],

    itensAcesso(itens) {
        var i
        var permitidos = new Array()

        for (i = 0; i < itens.length; i++) {
            if (itens[i].groups === undefined || itens[i].groups.length === 0) {
                if (itens[i].children !== undefined) {
                    itens[i].children = this.itensAcesso(itens[i].children)
                }
                permitidos.push(itens[i])
            }
        }

        return permitidos
    },

    filtrar(itens, pesquisa) {
        pesquisa = pesquisa.toLowerCase()
        var i
        var permitidos = new Array()

        for (i = 0; i < itens.length; i++) {
            var Cadastrar = itens[i].name.toLowerCase().includes(pesquisa)
            if (Cadastrar) {
                permitidos.push(itens[i])
            } else {
                if (itens[i].children !== undefined && itens[i].children.length > 0) {
                    if (this.filtrar(itens[i].children, pesquisa).length > 0) {
                        permitidos.push(itens[i])
                    }
                }
            }
        }

        return permitidos
    }
}
